<template>
  <!-- 详情头部菜单和大图标题公用组件 -->
  <div class="mobile-top-big-pic">
    <!-- 顶部大图加导航 -->
    <div class="top">
      <!-- 顶部logo大导航组件 -->
      <div class="about_top_logo">
        <mobileTopMenu></mobileTopMenu>
      </div>
      <div class="about_top" :style="{'background-image':'url('+topBgImg+')','background-repeat':'no-repeat'}">
        <div class="">
          <!-- 中部大标题——公司简介 -->
          <div class="about_top_bigtitle">
            <h1>{{bigTitle.enTitle}}</h1>
            <h2>{{bigTitle.znTitle}}</h2>
          </div>
        </div>
      </div>
    </div>

    <!-- 头部底部面包屑导航 -->
    <nav class="mobile-breadcrumb">
      <ul class="mobile-breadcrumb_cont">
        <li class="li home">
          <router-link to="/home">
            <!-- <a href="../..//index.html#/home"> -->
            <img src="../../assets/imgs/componentsPic/icon_home.png" />
            <!-- </a> -->
          </router-link>
        </li>
        <li class="li sort1 first hoverClass" ref="meunLi" @mouseover="mouseOverOne" @mouseleave="mouseLeaveOne">
          <a>{{menuLi.sortOne.title}}
            <i class="el-icon-arrow-down"></i>
          </a>
          <div>
            <router-link v-for="(item,i) in menuLi.sortOne.children" :key="i" :to="{path:item.url}" :class="item.active?'active':''">{{item.name}}
            </router-link>
          </div>
        </li>

        <li class="li hoverClass" ref="meunLiChildren" @mouseover="mouseOverTwo" @mouseleave="mouseLeaveTwo">
          <!-- <router-link :to="{path:menuLi.sortTwo.url}">{{menuLi.sortTwo.title}}</router-link> -->

          <a>{{menuLi.sortTwo.title}}
            <i class="el-icon-arrow-down"></i>
          </a>
          <div v-if="menuLi.sortOne.title==='职等你来'">
            <router-link v-for="(item,i) in menuLi.sortTwo.children" :key="i" :to="{path:item.url}" :class="item.active?'active':''" @click.native="refresh">{{item.name}}
            </router-link>
          </div>
          <div v-else>
            <router-link v-for="(item,i) in menuLi.sortTwo.children" :key="i" :to="{path:item.url}" :class="item.active?'active':''">{{item.name}}
            </router-link>
          </div>

        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import mobileTopMenu from "@/components/global/mobileTopMenu";
export default {
  props: {
    topBgImg: {
      type: String,
      default: "",
    },
    bigTitle: {
      type: Object,
      default: {},
    },
    menuLi: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      mouseOneFlag: true,
    };
  },
  methods: {
    refresh() {
      this.$router.go(0);
    },
    // 移动端点击事件代替鼠标移入移入事件
    // clickone(e) {
    //   if (this.mouseOneFlag) {
    //     // 模拟移入 第一次点击
    //     this.mouseOverOne(e);
    //   } else {
    //     // 模拟移出 第二次点击
    //     this.mouseLeaveOne(e);
    //   }
    //   this.mouseOneFlag = !this.mouseOneFlag;
    // },
    // 鼠标移入事件。操作一级菜单展示它下面所有的子菜单
    mouseOverOne(e) {
      // 根据html结构，当一级菜单li存在子菜单div时
      if (this.$refs.meunLi.children[1]) {
        // 计算出子菜单个数
        var h = this.$refs.meunLi.children[1].children.length;
        // 根据每个子菜单高度，计算出展示的下拉高度
        this.$refs.meunLi.children[1].style.height = h * 13.02 + "vw";
        //给自身移入时添加激活样式on
        e.currentTarget.className = "li hoverClass sort1 on";
        //自身li种a标签文字字体颜色更改为#666
        e.currentTarget.children[0].style =
          "color:#666;border-bottom:1px solid #EDEFEE";
        //当自身一级菜单激活时，所有div种的二级菜单文字字体颜色更改为#666
        for (var i = 0; i < e.currentTarget.children[1].children.length; i++) {
          e.currentTarget.children[1].children[i].style = "color:#666";
        }
      }
    },
    // 鼠标移除事件，操作一级菜单隐藏下面所有子菜单
    mouseLeaveOne(e) {
      //过程与鼠标移入相反
      if (this.$refs.meunLi.children[1]) {
        this.$refs.meunLi.children[1].style.height = "0";
        e.currentTarget.className = "li hoverClass sort1 close";
        e.currentTarget.children[0].style = "color:#d0d0d0";
        for (var i = 0; i < e.currentTarget.children[1].children.length; i++) {
          e.currentTarget.children[1].children[i].style = "color:#d0d0d0";
        }
      }
    },

    //二级子菜单
    mouseOverTwo(e) {
      // 根据html结构，当一级菜单li存在子菜单div时
      if (this.$refs.meunLiChildren.children[1]) {
        // 计算出子菜单个数
        var h = this.$refs.meunLiChildren.children[1].children.length;
        // 根据每个子菜单高度，计算出展示的下拉高度
        this.$refs.meunLiChildren.children[1].style.height = h * 13.02 + "vw";
        //给自身移入时添加激活样式on
        e.currentTarget.className = "li sort1 hoverClass on";
        //自身li种a标签文字字体颜色更改为#666
        e.currentTarget.children[0].style =
          "color:#666;border-bottom:1px solid #EDEFEE";
        //当自身一级菜单激活时，所有div种的二级菜单文字字体颜色更改为#666
        for (var i = 0; i < e.currentTarget.children[1].children.length; i++) {
          e.currentTarget.children[1].children[i].style = "color:#666";
        }
      }
    },
    // 鼠标移除事件，操作一级菜单隐藏下面所有子菜单
    mouseLeaveTwo(e) {
      //过程与鼠标移入相反
      if (this.$refs.meunLiChildren.children[1]) {
        this.$refs.meunLiChildren.children[1].style.height = "0";
        e.currentTarget.className = "li sort1 hoverClass close";
        e.currentTarget.children[0].style = "color:#d0d0d0";
        for (var i = 0; i < e.currentTarget.children[1].children.length; i++) {
          e.currentTarget.children[1].children[i].style = "color:#d0d0d0";
        }
      }
    },

    // downGb(e) { //点击本页导航
    //     // 过程与鼠标移入相反
    //     if (this.$refs.meunLi.children[1]) {
    //         this.$refs.meunLi.children[1].style.height = "0";
    //         e.currentTarget.className = "li sort1";
    //         e.currentTarget.children[0].style = "color:#d0d0d0";
    //         for (var i = 0; i < e.currentTarget.children[1].children.length; i++) {
    //             e.currentTarget.children[1].children[i].style = "color:#d0d0d0";
    //         }
    //     }
    // }
  },
  components: {
    mobileTopMenu,
  },
};
</script>

<style lang="scss" scoped>
.mobile-top-big-pic {
  /* 顶部大图导航公共组件 */
  .top {
    width: 100vw;
    overflow: hidden;
    height: 2524px;
  }
  .about_top {
    width: 100vw;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    height: 2524px;
    animation: aboutTopbg both ease-in-out 1.6s;
    z-index: 9;
  }
  .about_top_logo {
    height: 156px;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 99;
  }

  .about_top_bigtitle {
    position: relative;
    top: 960.5px;
    animation: aboutTitle both 0.4s 0.7s;
    h1,
    h2 {
      color: #ffffff;
      text-align: center;
    }

    h1 {
      font-size: 167px;
      font-family: bannerEn;
      font-weight: 400;
      margin: 0 auto;
      // width: 1920px;
      width: 1450px;
    }

    h2 {
      font-size: 142px;
      font-weight: 500;
      margin-top: 142px;
    }
  }
  /* 面包屑导航 */
  .mobile-breadcrumb {
    width: 100vw;
    background: rgba(0, 0, 0, 0.4);
    height: 250px;
    position: absolute;
    top: 2276px;
    z-index: 9;
    .mobile-breadcrumb_cont {
      position: relative;
      max-width: 1920px;
      margin: 0 auto;
      padding: 0 76px;
      display: flex;
    }
    .home {
      width: 280px;
      height: 250px;
      background: #2185f0;
      border-right: none;
      display: grid;
      place-content: center;
      a {
        text-align: center;
        width: 120px;
        height: 120px;
      }
      img {
        width: 120px;
        height: 120px;
        overflow: hidden;
        vertical-align: middle;
      }
    }
    .hoverClass {
      display: block;
      position: relative;
      float: left;
      width: 940px;
      // height: 13.021vw;
      &.first {
        border-right: 1px solid rgba(208, 208, 208, 0.3);
      }
      box-sizing: border-box;
      // &:hover {
      //   .el-icon-arrow-down {
      //     transform: rotate(180deg);
      //     top: 30%;
      //   }
      // }
      div {
        // height: 0;
        // overflow: hidden;
        transition: all 0.5s;
      }
      a {
        position: relative;
        display: block;
        color: #d0d0d0;
        font-size: 70px;
        font-weight: 400;
        line-height: 250px;
        text-align: left;
        overflow: hidden;
        transition: color 0.4s;
        white-space: nowrap;
        padding: 0 75px;
        &:hover {
          background: #f7f7f7;
          color: #000 !important;
        }
      }
    }
    .close {
      height: 13.021vw;
    }
    /*   .mobile-breadcrumb .li div > a {
      height: 50px;
      line-height: 50px;
    } */
  }
}
</style>